import Navbar from '@/components/base/Navbar';
import Footer from '@/components/base/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedSection from './components/FeaturedSection';
import TVSection from './components/TVSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedSection />
        <TVSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}